module.exports = __webpack_public_path__ + "img/main_partner2026.0d1b1053.png";